/* StraDerm – Collection Add to cart (independent de Debutify) */
(function() {
  "use strict";

  if (window.__sdCollectionAtcInit) return;
  window.__sdCollectionAtcInit = true;

  var LOADING_CLASS = "is-loading";
  var ADDED_CLASS = "is-added";
  var ERROR_CLASS = "is-error";
  var RESET_DELAY = 2000;
  var FLY_DURATION = 750;

  var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function setText(wrapper, text) {
    var el = wrapper.querySelector(".sd-collection-atc__text");
    if (el && text) el.textContent = text;
  }

  function setState(wrapper, state, text) {
    wrapper.classList.remove(LOADING_CLASS, ADDED_CLASS, ERROR_CLASS);
    if (state) wrapper.classList.add(state);
    if (text) setText(wrapper, text);
  }

  function resetLater(wrapper) {
    clearTimeout(wrapper.__sdResetTimer);
    wrapper.__sdResetTimer = setTimeout(function() {
      setState(wrapper, null, wrapper.dataset.label);
    }, RESET_DELAY);
  }

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && getComputedStyle(el).visibility !== "hidden";
  }

  function getCartIcon() {
    var links = document.querySelectorAll(".site-header a.cart-link, a.cart-link, .js-drawer-open-button-right");
    for (var i = 0; i < links.length; i++) {
      if (isVisible(links[i])) return links[i];
    }
    return null;
  }

  function getProductImage(wrapper) {
    var card = wrapper.closest("[data-product-card]");
    if (!card) return null;
    var imgs = card.querySelectorAll(".grid-product__image-wrapper img, .grid-product__image-link img, img");
    for (var i = 0; i < imgs.length; i++) {
      if (isVisible(imgs[i]) && (imgs[i].currentSrc || imgs[i].src)) return imgs[i];
    }
    return null;
  }

  /* Horizon-style fly-to-cart: the product image lifts, shrinks and arcs into the cart icon */
  function flyToCart(wrapper) {
    return new Promise(function(resolve) {
      var img = getProductImage(wrapper);
      var cart = getCartIcon();
      if (reduceMotion || !img || !cart || !Element.prototype.animate) return resolve();

      var from = img.getBoundingClientRect();
      var to = cart.getBoundingClientRect();
      var startSize = Math.min(from.width, from.height, 160);
      var endSize = 22;

      var startX = from.left + from.width / 2;
      var startY = from.top + from.height / 2;
      var endX = to.left + to.width / 2;
      var endY = to.top + to.height / 2;
      // If the header is scrolled out of view, aim just above the viewport, top-right
      if (endY < -40 || endY > window.innerHeight) {
        endX = window.innerWidth - 40;
        endY = -20;
      }

      // Outer layer moves on X, inner on Y with different easings → curved path
      var flyX = document.createElement("div");
      var flyY = document.createElement("div");
      var dot = document.createElement("div");
      flyX.className = "sd-fly-to-cart";
      flyY.className = "sd-fly-to-cart__y";
      dot.className = "sd-fly-to-cart__item";
      dot.style.width = startSize + "px";
      dot.style.height = startSize + "px";
      dot.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      flyX.style.left = startX + "px";
      flyX.style.top = startY + "px";
      flyY.appendChild(dot);
      flyX.appendChild(flyY);
      document.body.appendChild(flyX);

      var dx = endX - startX;
      var dy = endY - startY;
      var scale = endSize / startSize;
      var opts = { duration: FLY_DURATION, fill: "forwards" };

      flyX.animate(
        [{ transform: "translateX(0)" }, { transform: "translateX(" + dx + "px)" }],
        Object.assign({ easing: "cubic-bezier(0.4, 0, 0.6, 1)" }, opts)
      );
      flyY.animate(
        [{ transform: "translateY(0)" }, { transform: "translateY(" + dy + "px)" }],
        Object.assign({ easing: "cubic-bezier(0.55, -0.35, 0.85, 0.45)" }, opts)
      );
      var anim = dot.animate(
        [
          { transform: "translate(-50%, -50%) scale(1)", borderRadius: "12px", opacity: 1, offset: 0 },
          { transform: "translate(-50%, -50%) scale(" + Math.max(scale * 3, 0.45) + ")", borderRadius: "50%", opacity: 1, offset: 0.35 },
          { transform: "translate(-50%, -50%) scale(" + scale + ")", borderRadius: "50%", opacity: 0.85, offset: 1 }
        ],
        Object.assign({ easing: "ease-in-out" }, opts)
      );

      var done = function() {
        flyX.remove();
        resolve();
      };
      anim.onfinish = done;
      setTimeout(done, FLY_DURATION + 200); // safety net
    });
  }

  function bumpCartIcon() {
    var cart = getCartIcon();
    if (!cart || reduceMotion || !Element.prototype.animate) return;
    var icon = cart.querySelector(".material-icons-outlined, .material-icons, svg") || cart;
    icon.animate(
      [
        { transform: "scale(1)" },
        { transform: "scale(1.3) rotate(-8deg)" },
        { transform: "scale(0.9) rotate(4deg)" },
        { transform: "scale(1.05)" },
        { transform: "scale(1)" }
      ],
      { duration: 550, easing: "ease-out" }
    );
  }

  function updateCartCount(cart, animate) {
    if (!cart || typeof cart.item_count !== "number") return;

    document.querySelectorAll(".cart-count").forEach(function(el) {
      el.textContent = cart.item_count;
      if (animate && !reduceMotion && el.animate) {
        el.animate(
          [{ transform: "scale(1)" }, { transform: "scale(1.6)" }, { transform: "scale(1)" }],
          { duration: 400, easing: "cubic-bezier(0.34, 1.56, 0.64, 1)" }
        );
      }
    });

    document.querySelectorAll(".cart-link__bubble").forEach(function(el) {
      el.classList.toggle("cart-link__bubble--visible", cart.item_count > 0);
    });
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then(function(res) {
      return res.json();
    });
  }

  function syncDrawer(openDrawer) {
    var drawer = window.CartDrawer && window.CartDrawer.instance;
    if (drawer) {
      if (openDrawer && typeof drawer.open === "function" && !drawer.isOpen) {
        drawer.open(); // open() already calls refresh()
      } else if (typeof drawer.refresh === "function") {
        drawer.refresh(); // keep drawer contents up to date without opening it
      }
    } else if (openDrawer && window.timber && timber.RightDrawer && typeof timber.RightDrawer.open === "function") {
      timber.RightDrawer.open();
    }
  }

  function addToCart(wrapper, variantId) {
    if (!variantId || wrapper.classList.contains(LOADING_CLASS)) return;

    var openDrawer = wrapper.dataset.openDrawer === "true";
    var animate = wrapper.dataset.animation === "true";

    setState(wrapper, LOADING_CLASS);

    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || "Add to cart failed");
          return data;
        });
      })
      .then(function() {
        setState(wrapper, ADDED_CLASS, wrapper.dataset.addedLabel || wrapper.dataset.label);
        resetLater(wrapper);

        var cartPromise = fetchCart().catch(function() { return null; });
        var flyPromise = animate ? flyToCart(wrapper) : Promise.resolve();

        return Promise.all([cartPromise, flyPromise]).then(function(results) {
          var cart = results[0];
          if (animate) bumpCartIcon();
          updateCartCount(cart, animate);
          syncDrawer(openDrawer);
          document.dispatchEvent(new CustomEvent("sd:collection-atc:added", { detail: { cart: cart } }));
        });
      })
      .catch(function(error) {
        console.warn("[StraDerm Collection ATC]", error && error.message);
        setState(wrapper, ERROR_CLASS, wrapper.dataset.errorLabel || (error && error.message));
        resetLater(wrapper);
      });
  }

  document.addEventListener("click", function(event) {
    var button = event.target.closest(".sd-collection-atc__button[data-variant-id]");
    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    addToCart(button.closest("[data-sd-collection-atc]"), button.dataset.variantId);
  });

  document.addEventListener("change", function(event) {
    var select = event.target.closest(".sd-collection-atc__select");
    if (!select || !select.value) return;

    var wrapper = select.closest("[data-sd-collection-atc]");
    addToCart(wrapper, select.value);
    select.selectedIndex = 0;
  });
})();
